import _get from 'lodash/get';
import _head from 'lodash/head';
import _map from 'lodash/map';
import _keys from 'lodash/keys';
import _startCase from 'lodash/startCase';

import initialState from './initialState';
import actionType from './actionTypes';

const refExplorerReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_REFEXPLORER_RECORDS_SUCCESS:
            const key = _keys(action.payload)[0];
            const columns = _keys(_head(_get(action.payload, key, [])));
            if (columns.length > 0) {
                return {
                    ...state,
                    rowData: _get(action.payload, key, []),
                    gridOptions: {
                        ...state.gridOptions,
                        columnDefs: _map(columns, (column) => ({
                            headerName: _startCase(column),
                            field: column,
                            dataType: column,
                        })),
                    },
                };
            }
            return {
                ...state, rowData: [],
            };
        case actionType.GET_REFEXPLORER_RECORDS_FAILURE:
            return {
                ...state,
                rowData: [],
                gridOptions: {
                    ...state.gridOptions,
                    columnDefs: [],
                },
            };
        case actionType.GET_ALL_REFEXPLORER_NAMES_SUCCESS:
            return {
                ...state,
                schemaNames: action.payload,
            };
        default:
            return state;
    }
};

export default refExplorerReducer;
